import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'
import { authApi } from 'shared/api/auth'

import {
  PasswordRecoveryCheckRequest,
  PasswordRecoveryCheckResponse
} from './passwordRecoveryCheck.types'

export const passwordRecoveryCheck = async (
  request: PasswordRecoveryCheckRequest
) => {
  const response = await authApi.post<PasswordRecoveryCheckResponse>(
    'password-recovery-check',
    request
  )
  return response.data
}

export const usePasswordRecoveryCheckMutation = (
  options?: ExtendableMutationOptions<
    PasswordRecoveryCheckResponse,
    PasswordRecoveryCheckRequest
  >
) => {
  return useMutation({
    mutationFn: passwordRecoveryCheck,
    ...options
  })
}
